import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Logo from "@/assets/uplift logo.png"

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/solutions", label: "Solutions" },
  { to: "/spare-parts", label: "Spare Parts" },
  { to: "/process", label: "Process" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const solid = true;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur border-b border-black/5 transition-all duration-300">
      <div className="px-6 md:px-12 flex items-center justify-between py-3">
        <Link to="/" className="flex items-center cursor-pointer">
          <span
            className="flex items-center rounded-lg transition-all duration-300 relative px-3 py-2"
          >
            {/* {!solid && (
              <span
                className="absolute inset-0 rounded-full blur-xl opacity-60"
                style={{
                  background:
                    "radial-gradient(ellipse at center, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.05) 50%, transparent 70%)",
                  transform: "scale(1.3, 0.85)",
                }}
              />
            )} */}
              <img
               src={Logo}
              alt="Uplift One Elevator Solutions Hub"
              className="h-12 md:h-14 w-auto object-contain"
            />
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  solid
                    ? isActive
                      ? "text-crest-orange"
                      : "text-crest-deep/70 hover:text-crest-orange"
                    : isActive
                    ? "text-crest-orange"
                   : "text-crest-deep/70 hover:text-crest-orange"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:0505664336"
            className={`hidden md:flex items-center gap-2 text-sm font-medium cursor-pointer whitespace-nowrap ${
              solid ? "text-crest-deep" : "text-white"
            }`}
          >
            <span className="w-7 h-7 flex items-center justify-center rounded-full border border-current/30">
              <i className="ri-phone-line text-sm"></i>
            </span>
            050 566 43 36
          </a>
          <Link
            to="/contact"
            className="hidden md:inline-flex items-center gap-2 bg-crest-orange text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-crest-orangeLight transition-colors cursor-pointer whitespace-nowrap"
          >
            REQUEST A QUOTE
            <i className="ri-arrow-right-up-line"></i>
          </Link>
          <button
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              solid
                ? "text-crest-deep hover:bg-black/5"
                : "text-white hover:bg-white/10"
            }`}
            aria-label="Toggle menu"
          >
            <i
              className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}
            ></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden mx-6 mt-3 rounded-xl bg-white border border-black/10 p-4 flex flex-col gap-1">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `px-3 py-2.5 rounded-md text-sm font-medium cursor-pointer ${
                  isActive
                    ? "bg-crest-orange/10 text-crest-orange"
                    : "text-crest-deep hover:bg-crest-cream"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="mt-2 inline-flex items-center justify-center gap-2 bg-crest-orange text-white text-sm font-semibold px-5 py-2.5 rounded-full cursor-pointer whitespace-nowrap"
          >
            REQUEST A QUOTE
          </Link>
        </div>
      )}
    </header>
  );
}